var FAVORITE_SLOT_TYPES_LOCAL_STORAGE_KEY = 'user-favorite-slots';
export function _getFavouriteSlotsKey(sportId) {
    return "".concat(sportId, "-").concat(FAVORITE_SLOT_TYPES_LOCAL_STORAGE_KEY);
}
export function _getFavoriteSlotTypesFromLocalStorage(sportId) {
    return JSON.parse(localStorage.getItem(_getFavouriteSlotsKey(sportId))) || [];
}
export function _saveFavoriteTypesToLocalStorage(favoriteSlotTypes, sportId) {
    localStorage.setItem(_getFavouriteSlotsKey(sportId), JSON.stringify(favoriteSlotTypes));
}
export function addFavoriteSlotType(slotType, sportId) {
    var favoriteSlotTypes = _getFavoriteSlotTypesFromLocalStorage(sportId);
    favoriteSlotTypes.push(slotType);
    _saveFavoriteTypesToLocalStorage(favoriteSlotTypes, sportId);
}
export function removeFavoriteSlotType(slotType, sportId) {
    var favoriteSlotTypes = _getFavoriteSlotTypesFromLocalStorage(sportId);
    var arrayIndex = favoriteSlotTypes.indexOf(slotType);
    if (arrayIndex !== -1) {
        favoriteSlotTypes.splice(arrayIndex, 1);
    }
    _saveFavoriteTypesToLocalStorage(favoriteSlotTypes, sportId);
}
export function isSlotTypeFavorite(slotType, sportId) {
    var favoriteSlotTypes = _getFavoriteSlotTypesFromLocalStorage(sportId);
    return favoriteSlotTypes.includes(slotType);
}



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/SlotLocalStorageManager.js